import type { EnumVersionPublicationStatusApi } from '@ingenico/api-sdk-device-management-private';
import type { OsVersionResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import type { VersionPublicationStatus } from '../../../models/applicationVersion.model';
import type { SearchOsVersionResponse } from '../../../models/searchOsVersion.model';
import { toIsoStringIfDate } from '../../utils/date.utils';

export function transformIncomingOSVersionStatusToInternalStatus(
  status?: EnumVersionPublicationStatusApi,
): VersionPublicationStatus | undefined {
  return status satisfies VersionPublicationStatus | undefined;
}

export function mapSearchOsVersionResponse({
  pagination,
  data,
}: OsVersionResourceListResponseV2Api): SearchOsVersionResponse {
  return {
    pagination,
    data: data.map(
      ({
        artifacts,
        creationDate,
        id,
        longDescription,
        osId,
        publisherId,
        shortDescription,
        status,
        versionNumber,
      }) => ({
        artifacts,
        creationDate: toIsoStringIfDate(creationDate),
        id,
        longDescription,
        osId,
        publisherId,
        shortDescription,
        status: transformIncomingOSVersionStatusToInternalStatus(status),
        versionNumber,
      }),
    ),
  };
}
